// extracted by mini-css-extract-plugin
export var readonly = "_g3-1";
export var star = "_g3-0";